export default  {
    bindings: {
        source: '<',
        type: '@',
        formTab: '='
    },
    controller: 'crossFormController',
    template: require('../views/cross.form.html')
  };
  


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/components/cross.form.component.js